import { StyleSheet, Text, View } from "react-native";

import {
  fonts,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

import { Logomark } from "./Logomark";

export function BrandMark({
  tone = "default",
  size = "md",
}: {
  tone?: "default" | "inverse";
  size?: "sm" | "md" | "lg" | "xl";
}) {
  const { stylesheet, sizeStyles } = useThemedStyles(makeStyles);
  const inverse = tone === "inverse";
  return (
    <View style={stylesheet.wrapper}>
      <Logomark size={iconSizes[size]} />
      <Text
        accessibilityRole="header"
        style={[
          stylesheet.mark,
          sizeStyles[size],
          inverse ? stylesheet.inverse : null,
        ]}
      >
        gear<Text style={stylesheet.bold}>sync</Text>
      </Text>
    </View>
  );
}

const iconSizes = { sm: 18, md: 22, lg: 26, xl: 32 };

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    wrapper: {
      flexDirection: "row",
      alignItems: "center",
      gap: spacing.s,
    },
    mark: {
      color: colors.heading,
      fontFamily: fonts.regular,
      letterSpacing: -0.3,
    },
    inverse: { color: colors.onSteel },
    bold: { fontFamily: fonts.bold },
    sm: { fontSize: 18 },
    md: { fontSize: 24 },
    lg: { fontSize: 28 },
    xl: { fontSize: 36 },
  });
  return {
    stylesheet,
    sizeStyles: {
      sm: stylesheet.sm,
      md: stylesheet.md,
      lg: stylesheet.lg,
      xl: stylesheet.xl,
    },
  };
};
